module.exports = __webpack_public_path__ + "static/media/205B-1205B.c22a4dd3.png";